module.exports = __webpack_public_path__ + "img/camera-off.b36b127b.svg";